package it.neckar.lizergy.model.project.process.state

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.processStates.ProcessStateEntryId
import it.neckar.processStates.ProcessStatePhase
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("AdvanceInvoiceProcessStateEntry")
data class AdvanceInvoiceProcessStateEntry(
  override val id: ProcessStateEntryId,
  override val processState: AdvanceInvoiceProcessStates,
  override val assignedTo: UserLoginName,
  override val belongsTo: CompanyCode,
  override val assignedAt: IsoMillis,
  override val assignedBy: UserLoginName,
  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : LizergyProcessStateEntry {

  override val availableOptions: List<AdvanceInvoiceProcessStates>
    get() = AdvanceInvoiceProcessStates.entries

  override fun format(i18nConfiguration: I18nConfiguration): String {
    return processState.format(i18nConfiguration)
  }

  @Serializable
  @SerialName("AdvanceInvoiceProcessStates")
  enum class AdvanceInvoiceProcessStates : LizergyProcessStates {
    Missing,
    Sent,
    Paid,

    ;

    override val inPhase: ProcessStatePhase
      get() = when (this) {
        Missing -> ProcessStatePhase.Untouched
        Sent -> ProcessStatePhase.Waiting
        Paid -> ProcessStatePhase.Done
      }

    override fun format(i18nConfiguration: I18nConfiguration): String {
      return when (this) {
        Missing -> "AZ fehlt"
        Sent -> "AZ gestellt"
        Paid -> "AZ gezahlt"
      }
    }
  }
}
